'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'hideOnFilter', () => ({

		hideEls  : document.querySelectorAll( '[data-hide-on-filter]' ),
		unhideEls: document.querySelectorAll( '[data-unhide-on-filter]' ),

		manageVisibility() {

			if ( 0 < FWP.facets['search'].length ) {
				this.hideEls.forEach( element => element.classList.add( 'hidden' ) );
				this.unhideEls.forEach( element => element.classList.remove( 'hidden' ) );
			} else {
				this.hideEls.forEach( element => element.classList.remove( 'hidden' ) );
				this.unhideEls.forEach( element => element.classList.add( 'hidden' ) );
			}
		},

		init() {

			if ( 0 === this.hideEls.length ) return false;

			document.addEventListener( 'facetwp-refresh', () => {
				this.manageVisibility();
			});
		}

	}) );
});
